<script type="text/javascript">
  export default {
    props: ['website'],
    data() {
      return {
        verbiage: [
          {
            title: 'Mission',
            description: 'REVINRE aims to revolutionize the real estate industry by providing innovative solutions for home sellers and buyers.',
          },
          {
            title: `Mission Statement`,
            description: `At REVINRE, we embark on a bold mission to revolutionize the real estate industry. Our vision is to empower homeowners, buyers, and sellers with innovative solutions that challenge the status quo.`,
          },
          {
            title: `Customized vs Full Service`,
            description: `REVINRE's customized services charge a fixed rate regardless of the property's selling price, offering potential cost savings. REVINRE's full services, however, typically operate on commission-based models, with agents receiving a percentage of the sale price. While REVINRE's customized services may provide limited support, REVINRE's full services often offer comprehensive assistance throughout the selling or buying process.`,
          },
          {
            title: `Empowering Homeowners`,
            description: `- We believe in putting the power back into the hands of homeowners. Selling or buying a home should not be daunting—it should be empowering. <br> - Our mission is to provide tools, transparency, and control to homeowners, allowing them to navigate the real estate journey confidently.`,
          },
          {
            title: `Cost Efficiency and Savings`,
            description: `- Traditional real estate transactions often come with hefty commissions. Not at REVINRE. <br> - We offer a groundbreaking approach: a 0% listing fee. Yes, you read that right. Sellers can list their homes without paying the typical agent commission. <br> - On average, our clients save around $14,250 compared to traditional agents. That’s money back in your pocket.`,
          },
          {
            title: `Customization and Flexibility`,
            description: `- One size does not fit all. That’s why we offer customized services. <br> - You choose what you need. Whether it’s marketing, showings, or paperwork, pay only for the services that matter to you. <br> - No rigid packages—just tailored solutions.`,
          },
          {
            title: `FSBO Pros and Cons`,
            description: `<h4>Pros of FSBO:</h4><br>
            1: Saving on Listing Agent Commission:<br>
            - FSBO allows homeowners to avoid paying a listing agent commission. Typically, sellers pay between 5-6% of the home sale price as their fee.<br>
            - For example, if a house sells for $300,000, the commission would be $15,000. Going FSBO, you’d still need to pay the 2-3% buyer’s agent commission, resulting in potential savings.<br>
            2: Complete Control of the Process:<br>
            - FSBO gives you full control over the home sale process.<br>
            - If you know how to market your home, set the right price, and negotiate offers, FSBO empowers you to make decisions independently.<br>
            <h4>Cons of FSBO:</h4><br>
            1: Lack of Professional Guidance:<br>
            - Without an agent, you’ll handle all aspects of the sale, including paperwork and negotiations.<br>
            - Homeowners lacking real estate experience may find this overwhelming.<br>
            2: Limited Exposure:<br>
            - FSBO listings may not reach as many potential buyers as those listed by agents on the MLS.<br>
            - Marketing and visibility can be challenging without professional assistance.<br>
            3: Risk of Mistakes:<br>
            - Inexperienced sellers may make costly errors during the process.<br>
            - Buyers also face risks when dealing with unseasoned sellers.<br>
            - In summary, FSBO offers cost savings and control but requires expertise. Consider your comfort level and needs when deciding between FSBO and hiring a realtor.<br>`,
          },
          {
            title: `Traditional Agent Pros and Cons`,
            description: `<h4>Pros of Working with a Real Estate Agent:</h4><br>
            1: Expertise and Guidance:<br>
            - Real estate agents bring professional knowledge to the table. They understand market trends, pricing, and legal intricacies.<br>
            - Their guidance ensures a smoother buying or selling process.<br>
            2: Market Insights:<br>
            - Agents have access to MLS data and can provide comparable property analysis.<br>
            - They help you make informed decisions based on local market conditions.<br>
            3: Negotiation Skills:<br>
            - Agents are skilled negotiators. They advocate for your interests during price negotiations.<br>
            - Their expertise can lead to better deals.<br>
            4: Network and Connections:<br>
            - Agents have a vast network of professionals—inspectors, lenders, contractors, etc.<br>
            - They connect you with reliable service providers.<br>
            5: Time Savings:<br>
            - Agents handle paperwork, showings, and administrative tasks.<br>
            - You focus on other aspects of your life.<br>
            <h4>Cons of Working with a Real Estate Agent:</h4><br>
            1: Cost:<br>
            - Commissions: Agents earn a percentage of the sale price (usually 5-6%).<br>
            - Additional Fees: Buyers may face closing costs.<br>
            2: Dependency:<br>
            - You rely on the agent’s availability and responsiveness.<br>
            - Misaligned priorities can be frustrating.<br>
            3: Limited Control:<br>
            - Agents make decisions on your behalf.<br>
            - Some sellers prefer more hands-on involvement.<br>
            4:Quality Varies:<br>
            - Not all agents provide exceptional service.<br>
            - Research and choose wisely.<br>
            - In summary, working with an agent offers expertise and convenience but comes with costs. Consider your needs and preferences when deciding.<br>`,
          },
        ],
      }
    },
    created() {

    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <w-site-navbar
      :website="website"
      :static="1"
    ></w-site-navbar>
    <main>

      <section class="overflow-hidden">
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" style="background-image: url(https://s3.revinre.com/website/Development/background_09.jpg);"></div>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0">
          <!-- <iframe src="https://www.youtube.com/embed/SglNxlFUOjM?si=yBI_npIqJGyO4RzW&autoplay=1&mute=1&controls=0&loop=1&playlist=SglNxlFUOjM" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen style="width:100%;height:100%;"></iframe> -->
          <video autoplay muted loop class="_w-n-100p _h-n-100p"><source src="/storage/fm/revinre-nc/video-bg-4.mp4" type="video/mp4"></video>
        </div>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 bg-white _o-7"></div>
        <div class="container-fluid pt-17 pb-15 m_py-35">
          <div class="row justify-content-center">
            <div class="col-lg-6">
              <div class="home-content text-center mb-4">
                <h1 class="mb-3 text-black" data-aos="fade-zoom-in">Sell your home and save thousands</h1>
                <p class="text-dark"  data-aos="fade-zoom-in">0% Listing fee | Average savings of $14,250 | 4.7 Star rating on Google</p>
                <div class="row mt-5">
                  <div class="col-sm px-sm-1"><a data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-revinre aos-init" style="background: #396d55;border-color: #396d55;color: white;">I'm selling</a></div>
                  <div class="col-sm px-sm-1"><a data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">I'm buying</a></div>
                  <div class="col-sm px-sm-1"><a data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">Home valuation</a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="position-absolute _pos-l-0 _pos-b-0 _pos-r-0 text-center">
          <ul class="list-inline">
            <li class="list-inline-item mx-3" v-tippy content="Visit us on Facebook"><a class="text-white" data-aos="fade-zoom-in"><Icon icon="ri:facebook-fill" height="20"></Icon></a></li>
            <li class="list-inline-item mx-3" v-tippy content="Visit us on Twitter"><a class="text-white" data-aos="fade-zoom-in"><Icon icon="ri:twitter-line" height="20"></Icon></a></li>
            <li class="list-inline-item mx-3" v-tippy content="Visit us on Instagram"><a class="text-white" data-aos="fade-zoom-in"><Icon icon="ri:instagram-line" height="20"></Icon></a></li>
            <li class="list-inline-item mx-3" v-tippy content="Visit us on YouTube"><a class="text-white" data-aos="fade-zoom-in"><Icon icon="ri:youtube-line" height="20"></Icon></a></li>
          </ul>
        </div>
      </section>

      <section class="" style="background: #396d55;color: white;">
        <div class="container-fluid py-2">
          <div class="row m-0">
            <div class="col p-0">
              <p class="py-2">Just a header to demonstrate using a video background. Below is some AI generated verbaige.</p>
            </div>
            <div class="_w-150 text-right">
              <button tyle="button" class="btn btn-block btn-outline-white">Get Started</button>
            </div>
          </div>
          
        </div>
      </section>

      <section class="section">
        <div class="container-fluid py-6">

          <div class="row justify-content-center">
            <div v-for="(item, item_i) in verbiage" :key="item_i" class="col-7 mb-5">
              <h1>{{ item.title }}</h1>
              <p v-html="item.description"></p>
            </div>
          </div>
          
          
        </div>
      </section>

    </main>

    <w-site-footer
      :website="website"
    ></w-site-footer>

  </section>
</template>
